
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import {
  CompanyListOfQuotaDto,
  getCompanyListOfQuota,
  jump2Quota,
  jump2Repayment,
  toQuotaResDto
} from '@/api/customerManage'
import CustomerCardApply from '@/views/financial/CustomerCardApply.vue'
import { openNewPage, backToBefore } from '@/utils/h5ToApp'
import { getRobotization } from '@/api/guarantee'

Component.registerHooks(['beforeRouteEnter'])

@Component({
  name: 'ApplyQuota',
  components: {CustomerCardApply}
})
export default class ApplyQuota extends Vue {
  @Getter companyId!: string
  @Getter mobile!: string
  @Getter info: any // 用户信息

  customerList: CompanyListOfQuotaDto[] = []
  refreshing = false
  loading = false
  finished = false
  params = {
    companyId: '',
    type: 1, // 金融服务类型
    pageIndex: 1,
    pageSize: 10
  }
  fromPage = '' // fromPage=='1'的时候，说明是原生跳转过来的，此时，返回按钮需要调用原生返回方法
  merchantId = '' // 选中的客户编号
  merchantName = '' // 选中的客户公司名称

  beforeRouteEnter (to, from, next) {
    const type = Number(to.query.applyType)
    if (type === 1) {
      to.meta.title = '去出额'
    } else if (type === 2) {
      to.meta.title = '去借款'
    } else if (type === 3) {
      to.meta.title = '去还款'
    }
    next()
  }

  created () {
    this.params.companyId = this.companyId
    this.params.type = Number(this.$route.query.applyType)
    this.fromPage = this.$route.query.fromPage
        ? (this.$route.query.fromPage as string)
        : '0'
    this.getList()
  }

  getList () {
    getCompanyListOfQuota(this.params)
        .then((res) => {
          if(res.code==='000002'){
            this.$dialog.alert({
              message: res.msg,
            })
          }else {
            this.customerList = res.data.records || []
            if (this.customerList.length >= res.data.totalRecords) {
              this.finished = true
            } else {
              this.finished = false
            }
          }
        })
        .finally(() => {
          this.refreshing = false
        })
  }

  handleBack () {
    if (this.fromPage === '1') {
      backToBefore()
    } else {
      this.$router.back()
    }
  }

  /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getList()
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++
    this.loading = true
    getCompanyListOfQuota(this.params)
        .then((res) => {
          if(res.code==='000002'){
            this.$dialog.alert({
              message: res.msg,
            })
          }else {
            this.loading = false
            this.customerList = this.customerList.concat(res.data.records)
            if (this.customerList.length >= res.data.totalRecords) {
              this.finished = true
            }
          }
        })
        .finally(() => {
          this.refreshing = false
        })
  }

  selectApplyCustomer (id: string, name: string) {
    this.merchantId = this.merchantId === id ? '' : id
    this.merchantName = this.merchantName === name ? '' : name
  }

  sureFunc () {
    if (!this.merchantId) {
      return this.$toast('请选择您的客户')
    }
    if ( this.params.type === 1) { // 去出额
      this.toQuota()
    }
    else if ( this.params.type === 2) { // 去借款
      //    跳转到订单选择页面
      this.$router.push({
        path: '/orderSelect',
        query: {
          id: this.merchantId
        }
      })
    }
    else if ( this.params.type === 3) { // 去还款
      //    跳转到飞贷免登录
      const obj = {
        companyId: this.companyId,
        merchantId: this.merchantId,
        userMobile: this.mobile,
        // isAuthorized: true
      }
      jump2Repayment(obj).then((res) => {
        this.toFreeLogin(res.data)
      })
    }
  }

  /**
   * 去出额
   * @param isAuthorized 是否授权，默认false
   */
  toQuota () {
    const obj = {
      companyId: this.params.companyId,
      merchantId: this.merchantId
    }
    jump2Quota(obj).then((res) => {
      if (res.code === '000000') {
        //    跳转到免登录产融h5
        this.toFreeLogin(res.data)
      } else if(res.code === '000004') {
        this.$dialog.confirm({
          message: '需完成企业认证才可在该核心企业下进行出额',
          confirmButtonText: '去认证'
        }).then(() => {
          this.$router.push({
            path: '/companyInfoForm',
            query: {
              formPage: 'h5'
            }
          })
        })
      } else if (res.code === '000005') {
        this.$toast('仅法人或股东可申请')
      }
    })
  }

  /**
   * 跳转到免登录页面
   * @param data 后端接口返回数据
   */
  toFreeLogin (data: toQuotaResDto) {
    // let redirectUrl = 'http://172.16.101.69:8088/#/loginFree?as=CYTCS001&cs=1000&orderId=24b3bf8c-1570-455f-9da8-7b33efe62283&client=0&industryType='
    openNewPage({url: encodeURI(data.redirectUrl)})
  }
}
